<template>
  <div @click="handleClick" class="CompletedLabel">
    <div class="CompletedLabelContainer">
      <img
        class="CompletedLabelIcon"
        :class="[completed ? 'active' : '']"
        src="../assets/img/completed.svg"
        alt="completed"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CompletedLabel",
  props: {
    uid: String,
    completed: Boolean,
  },
  methods: {
    ...mapActions(["updateCompletedList"]),
    handleClick(e) {
      e.stopPropagation();
      this.updateCompletedList(this.uid);
    },
  },
};
</script>

<style lang="scss" scoped>
.CompletedLabelContainer {
  width: 30px;
  height: 30px;
  border: 1px solid $color-light-grey;
  border-radius: 45px;
  box-sizing: border-box;
}

.CompletedLabelIcon {
  display: none;
  width: 100%;
  &.active {
    display: block;
  }
}

@media screen and (max-width: 650px) {
  .CompletedLabel {
    margin-left: 8px;
  }
  .CompletedLabelContainer {
    width: 24px;
    height: 24px;
  }
}
</style>
